<div class="layout-row full-height layout-align-start-center">
  <a class="br-link-1 text-ellipsis" appBringozIdGenerator="images-link-popup-link" (click)="onOpen($event)">{{ (attachments()?.length === 1 ? 'X_IMAGE' : 'X_IMAGES') | translate: {sum: attachments()?.length || 0} }}</a>
</div>
